/**
 *  Genesys Products short name
 */
export enum ProductShortName {
  AGENT_PLATFORM = 'agent-platform',
  AP_ENGLISH = 'ap-nov2024-english',
  AP_SPANISH = 'ap-spanish',
  AP_PORTUGUESE = 'ap-portuguese',
  BEYOND = 'beyond',
  BEYOND_CX = 'beyond-cx',
  GENESYS_CLOUD = 'genesyscloud', // Same thing as Genesys Cloud
  GENESYS_CLOUD_EX = 'genesyscloud-ex',

  GENESYS_CLOUD_PARTNER = 'partner-genesyscloud', // New
  GENESYS_CLOUD_PARTNER_DIGITAL_PLUS = 'partner-gcx-digital-plus', // New
  GENESYS_CLOUD_PREMIER_PARTNER = 'partner-genesyscloud-premier', // New
  GENESYS_CLOUD_TRIAL = 'partner-genesyscloud-trial', // New

  GENESYS_ENGAGE = 'genesysengage', // Same thing a Genesys Multicloud (formerly Genesys Engage) or Genesys Engage on premises
  POINTILLIST = 'pointillist',
  PURE_CONNECT = 'pureconnect',
  AI_ESSENTIALS = 'ai-essentials',
}
